import React, { useState } from 'react';
import classnames from 'classnames';
import { useFlags } from 'launchdarkly-react-client-sdk';

// Types
import { Feature } from 'Shared/types/Organization.type';
import { FetchReviewsContext } from 'Shared/api/Reviews.api';

// Hooks
import { useFeature } from 'Shared/utils/hooks';
import { useResponsiveScreenWidth } from 'Wpds/hooks/useResponsiveScreenWidth';
import { useReviewsFetch } from 'Shared/utils/hooks/use-reviews-fetch';

// Components
import { WpMenu, WpMenuItem } from 'Wpds/components/menu';
import OpenReviews from './OpenReviews';
import PastReviews from './PastReviews';
import ReviewTemplates from './ReviewTemplates';
import SelfReviewStartedModal from './SelfReviewStartedModal/SelfReviewStartedModal';
import ReviewStartedModal from './ReviewStartedModal/ReviewStartedModal';
import ReviewCompilationCompletedModal from './ReviewCompilationCompleted/ReviewCompilationCompleted';
import PeerReviewCompletedModal from './PeerReviewCompletedModal/PeerReviewCompletedModal';
import ThreeSixtyFreePlanBlockerPage from '../../ThreeSixtyFreePlanBlockerPage/ThreeSixtyFreePlanBlockerPage';

// Styles
import './CoachingReviewsPage.scss';

enum TABS {
  open = 'open',
  past = 'past',
  templates = 'templates',
}

const CoachingReviewsPage = () => {
  const { isFreePlan } = useFeature(Feature.reviews);
  const { isLarge } = useResponsiveScreenWidth({ isAtMost: true });

  const { isFetching } = useReviewsFetch({ context: FetchReviewsContext.feedback_360 });
  const { featureFlag360ReviewTemplates } = useFlags();

  const [activeTab, setActiveTab] = useState(TABS.open);

  const baseClassName = 'CoachingReviewsPage';
  const classes = classnames(baseClassName, isLarge && `${baseClassName}--column`);

  if (isFreePlan) return <ThreeSixtyFreePlanBlockerPage withHeader={false} />;
  return (
    <>
      <div className={classes}>
        {isFetching ? (
          <>loading...</>
        ) : (
          <>
            <div className={`${baseClassName}__menu-wrapper`}>
              <div className={`${baseClassName}__menu-wrapper__menu`}>
                <WpMenu
                  activeItemId={activeTab}
                  onMenuItemClick={setActiveTab}
                  direction={isLarge ? 'horizontal' : 'vertical'}
                >
                  <WpMenuItem menuItemId={TABS.open}>Open Feedback</WpMenuItem>
                  <WpMenuItem menuItemId={TABS.past}>Past Feedback</WpMenuItem>
                  {featureFlag360ReviewTemplates && <WpMenuItem menuItemId={TABS.templates}>Templates</WpMenuItem>}
                </WpMenu>
              </div>
            </div>
            <div className={`${baseClassName}__body`}>
              {activeTab === TABS.open && <OpenReviews />}
              {activeTab === TABS.past && <PastReviews />}
              {activeTab === TABS.templates && <ReviewTemplates />}
            </div>
          </>
        )}
      </div>
      <SelfReviewStartedModal />
      <ReviewStartedModal />
      <ReviewCompilationCompletedModal />
      <PeerReviewCompletedModal />
    </>
  );
};

export default CoachingReviewsPage;
